document.addEventListener("DOMContentLoaded", () => {

  document.querySelectorAll(".comparison-slider").forEach((slider) => {

    const afterImage = slider.querySelector(".after-image");
    const handle = slider.querySelector(".comparison-handle");
    const hint = slider.querySelector(".comparison-hint"); // may be null — always guard it

    if (!afterImage || !handle) return;

    let dragging = false;
    let interacted = false;
    let raf = null;

    let position = Number(slider.dataset.position);
    if (isNaN(position)) position = 50;

    function update(value) {
      value = Math.max(0, Math.min(100, value));

      // clip-path is now applied directly to the full-size after-image,
      // so the percentage always matches the slider's own width — no
      // mismatched math from a hardcoded 50%-wide wrapper anymore.
      afterImage.style.clipPath = `inset(0 0 0 ${value}%)`;
      handle.style.left = value + "%";

      if (hint) hint.style.left = value + "%";

      slider.setAttribute("aria-valuenow", Math.round(value));
    }

    update(position);

    function moveToClientX(clientX) {
      const rect = slider.getBoundingClientRect();
      const value = ((clientX - rect.left) / rect.width) * 100;

      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => update(value));
    }

    function markInteracted() {
      if (interacted) return;
      interacted = true;
      if (hint) hint.classList.add("hide");
    }

    slider.addEventListener("pointerdown", (e) => {
      dragging = true;
      markInteracted();
      moveToClientX(e.clientX);
      slider.setPointerCapture(e.pointerId);
    });

    slider.addEventListener("pointermove", (e) => {
      if (!dragging) return;
      moveToClientX(e.clientX);
    });

    slider.addEventListener("pointerup", () => {
      dragging = false;
    });

    slider.addEventListener("pointercancel", () => {
      dragging = false;
    });

    // Keyboard accessibility: arrow keys nudge the slider by 2%
    slider.addEventListener("keydown", (e) => {
      const current = parseFloat(handle.style.left) || position;

      if (e.key === "ArrowLeft") {
        markInteracted();
        update(current - 2);
        e.preventDefault();
      } else if (e.key === "ArrowRight") {
        markInteracted();
        update(current + 2);
        e.preventDefault();
      }
    });

  });

});